import React, { useState } from 'react';
import { Container, Form, Button, Alert, Row, Col, Card } from 'react-bootstrap';
import InputMask from 'react-input-mask';

const numerosAutorizados = [
  '+55 (62) 99999-9999',
  '+55 (62) 98888-8888',
  '+55 (62) 98765-4321'
];

const ValidadorPix = () => {
  const [numero, setNumero] = useState('');
  const [valido, setValido] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
    const apiImg = process.env.REACT_APP_API_IMG;

  // const validarNumero = (e) => {
  //   e.preventDefault();
  //   const numeroFormatado = `+55 ${numero}`;
  //   const isAutorizado = numerosAutorizados.includes(numeroFormatado);
  //   setValido(isAutorizado);
  // };

  const validarNumero = async (e) => {
  e.preventDefault();
  // melhor: só dígitos; backend cuida do resto
  const numeroSemMascara = numero.replace(/\D/g, '');
  const numeroFormatado = numeroSemMascara; // sem +55 aqui; backend adiciona se faltar

  try {
    const response = await fetch(`${apiUrl}/pix/validar`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ numero: numeroFormatado })
    });
    const data = await response.json();
    setValido(!!data.autorizado);
  } catch (error) {
    console.error('Erro ao validar número:', error);
  }
};

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow-lg">
            <Card.Body>
              <h3 className="mb-4 text-center">Validação de Número PIX</h3>
              <p className="text-muted text-center">
                Digite o número que lhe enviou a chave PIX para verificar se é um canal oficial da empresa.
              </p>

              <Form onSubmit={validarNumero}>
                <Form.Group controlId="numeroTelefone">
                  <Form.Label>Número com DDD</Form.Label>
                  <InputMask
                    mask="(99) 99999-9999"
                    className="form-control"
                    placeholder="(62) 99999-9999"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    required
                  />
                </Form.Group>

                <div className="d-grid gap-2 mt-3">
                  <Button variant="primary" type="submit">
                    Validar Número
                  </Button>
                </div>
              </Form>

              {valido === true && (
                <Alert variant="success" className="mt-4 text-center">
                  ✅ Este número é oficial! Pode realizar o PIX com segurança.
                </Alert>
              )}

              {valido === false && (
                <Alert variant="danger" className="mt-4 text-center">
                  ⚠️ Este número <strong>não</strong> está registrado como canal oficial. Não realize o PIX!
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ValidadorPix;
